import { axiosInstance } from "../axios-client/axiosClient";

export const getFaqs = async () => {
    const api = axiosInstance();
    return await api.get("/api/faq/get-faqs");
};
